import React from 'react';
import { Table, Empty } from 'antd';
import moment from 'moment';
import { MailOutlined } from '@ant-design/icons';

const TicketDetailEmailLogList = ({ email_logs }) => {
    return (
        <>
            {
                email_logs?.length > 0 ?
                (
                    <>
                        <Table
                        scroll={{ x : 400, }}
                        className='hub-table bordered'
                        dataSource={email_logs}
                        pagination={false}
                        rowKey="ticket_email_log_id"
                        columns={[{
                            title : 'Receiver Email',
                            dataIndex : 'receiver_email',
                            key : 'receiver_email',
                            render : (text, row, index) => {
                                return (
                                    <>
                                    <MailOutlined style={{ marginRight: 8 }} /> 
                                        {text || '-'}
                                    </>
                                )
                            }
                        },{
                            title : 'Sent By',
                            dataIndex : 'created_by',
                            key : 'created_by',
                            render : (text, row, index) => {
                                return (
                                    <>
                                        {text || '-'}
                                    </>
                                )
                            }
                        },{
                            title : 'Sent At',
                            dataIndex : 'created_at',
                            key : 'created_at',
                            render : (date, row, index) => {
                                return (
                                    <>
                                        {date ? moment(date).format('DD MMM YYYY, hh:mm A') : '-'}
                                    </>
                                )
                            }
                        }]}
                        />
                    </>
                )
                :
                (
                    <>
                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                    </>
                )
            }
        </>
    );
};

export default TicketDetailEmailLogList;